var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex breakdance-dropdown-input"},[_c('v-autocomplete',{staticClass:"breakdance-dense-select breakdance-white-gray-outlined-input",attrs:{"items":_vm.items,"dense":"","solo":"","flat":"","filled":"","value":_vm.value,"hide-details":""},on:{"input":_vm.edit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }